import FootballPitch from '../../components/FootballPitch';

export default function QuoteSection() {
  return (
    <section style={{
      padding: '8rem clamp(1rem,4vw,3rem)',
      background: 'linear-gradient(135deg,rgba(13,27,42,0.97) 0%,rgba(21,35,53,0.97) 100%)',
      backgroundSize: '200% 200%',
      animation: 'bgShift 12s ease infinite',
      position: 'relative', overflow: 'hidden',
    }}>
      {/* Faint pitch bg */}
      <div style={{ position: 'absolute', inset: 0, opacity: 0.05, pointerEvents: 'none' }}>
        <FootballPitch style={{ width: '100%', height: '100%' }} />
      </div>

      <div style={{ maxWidth: 900, margin: '0 auto', textAlign: 'center', position: 'relative', zIndex: 2 }}>
        <div style={{
          fontSize: 80, color: 'var(--coral)', fontFamily: 'Georgia,serif',
          lineHeight: 0.5, marginBottom: '2rem', opacity: 0.3,
        }}>"</div>

        <blockquote className="vis" style={{
          fontFamily: 'var(--font-d)', fontWeight: 700, lineHeight: 1.3,
          textTransform: 'uppercase', letterSpacing: 1,
          fontSize: 'clamp(24px,3.5vw,40px)', marginBottom: '3rem',
          background: 'linear-gradient(90deg,var(--white),var(--coral),var(--white),var(--coral),var(--white))',
          backgroundSize: '300% auto',
          WebkitBackgroundClip: 'text',
          WebkitTextFillColor: 'transparent',
          animation: 'shimmerText 6s linear infinite 2s',
        }}>
          "88.5% of UAE are expats. Most never get scouted — not because they're not good enough, but because scouts don't watch neighbourhood games."
        </blockquote>

        <div style={{ fontFamily: 'var(--font-m)', fontSize: 12, color: 'var(--coral)', letterSpacing: 2 }}>
          — THE HADAFI MISSION
        </div>
      </div>
    </section>
  );
}
